<template>
    <v-app>
        <div id="nav">
            <app-navigation :schedules="schedules"></app-navigation>
        </div>

        <v-main>
            <router-view :schedules="schedules" />
        </v-main>
    </v-app>
</template>

<script>
import AppNavigation from "@/components/AppNavigation";

export default {
    name: "App",
    components: {
        AppNavigation
    },
    data: () => ({
        schedules: [
            {
                id: "ca-auhsd-ahs",
                name: "Acalanes High School",
                icon: "mdi-school",
                color: "#1A468F",
                path: "/schedule/ca-auhsd-ahs"
            },
            {
                id: "ca-auhsd-chs",
                name: "Campolindo High School",
                icon: "mdi-school",
                color: "#A80000",
                path: "/schedule/ca-auhsd-chs"
            }
        ]
    }),
    methods: {
        toggle_dark_mode: function() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
            localStorage.setItem(
                "dark_theme",
                this.$vuetify.theme.dark.toString()
            );
        }
    },
    mounted() {
        const theme = localStorage.getItem("dark_theme");
        if (theme) {
            if (theme == "true") {
                this.$vuetify.theme.dark = true;
            } else {
                this.$vuetify.theme.dark = false;
            }
        } else if (
            window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
        ) {
            this.$vuetify.theme.dark = true;
            localStorage.setItem(
                "dark_theme",
                this.$vuetify.theme.dark.toString()
            );
        }
    }
};
</script>

<style>
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
}

#nav {
    padding: 45px;
}
</style>
